import { useState } from "react";
import {
    DesvincularTemplateModulosController,
    ListarDocumentoTemplateModuloController,
    VincularModulosAoTemplateController,
} from "../../../../Controllers/Geral/TemplatesModulo/TemplatesModuloControllers";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import { IDocumentosTemplate } from "../../../../Interfaces/Geral/Documentos/DocumentosInterface";
import ModulosDesvinculados from "./ModulosDesvinculados/ModulosDesvinculados";
import ModulosVinculados from "./ModulosVinculados/ModulosVinculados";
import { IModulos } from "../../../../Interfaces/Geral/TemplatesModulo/TemplatesModuloInterface";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";

interface IGerenciarModulosTemplates {
    row: IDocumentosTemplate;
}

export default function GerenciarModulosTemplates(
    props: IGerenciarModulosTemplates
) {
    // const lstSelecionadosVinculados = useRef<Array<IModulos>>([]);
    // const lstSelecionadosDesvinculados = useRef<Array<IModulos>>([]);

    const [lstSelecionadosVinculados, setLstSelecionadosVinculados] = useState<
        Array<IModulos>
    >([]);

    const [lstSelecionadosDesvinculados, setLstSelecionadosDesvinculados] =
        useState<Array<IModulos>>([]);

    const {
        execute: VincularModulosAoTemplate,
        loading: VincularModulosAoTemplateLoading,
    } = useAsyncCallback(VincularModulosAoTemplateController);

    const {
        execute: DesvincularTemplateModulos,
        loading: DesvincularTemplateModulosLoading,
    } = useAsyncCallback(DesvincularTemplateModulosController);

    const {
        value: lstDocumentosTemplatesModulo,
        loading: lstDocumentosTemplatesModuloLoading,
        execute: ListarDocumentoTemplateModulo,
    } = useAsyncEffect(async () => {
        if (props.row.ID_DOCUMENTO_TEMPLATE)
            return ListarDocumentoTemplateModuloController(
                props.row.ID_DOCUMENTO_TEMPLATE
            );
    }, [props.row.ID_DOCUMENTO_TEMPLATE]);

    function HandleVincularModuloUnico(row: IModulos) {
        VincularModulosAoTemplate(props.row.ID_DOCUMENTO_TEMPLATE, [
            row.ID_MODULO,
        ]).then(() => {
            ListarDocumentoTemplateModulo();
            setLstSelecionadosVinculados([]);
            setLstSelecionadosDesvinculados([]);
        });
    }

    function HandleVincularModulosTodos() {
        VincularModulosAoTemplate(
            props.row.ID_DOCUMENTO_TEMPLATE,
            lstSelecionadosDesvinculados.map((p) => p.ID_MODULO)
        ).then(() => {
            ListarDocumentoTemplateModulo();
            setLstSelecionadosVinculados([]);
            setLstSelecionadosDesvinculados([]);
        });
    }

    function HandleDesvincularModuloUnico(row: IModulos) {
        DesvincularTemplateModulos(props.row.ID_DOCUMENTO_TEMPLATE, [
            row.ID_MODULO,
        ]).then(() => {
            ListarDocumentoTemplateModulo();
            setLstSelecionadosVinculados([]);
            setLstSelecionadosDesvinculados([]);
        });
    }

    function HandleDesvincularModuloTodos() {
        DesvincularTemplateModulos(
            props.row.ID_DOCUMENTO_TEMPLATE,
            lstSelecionadosVinculados.map((p) => p.ID_MODULO)
        ).then(() => {
            ListarDocumentoTemplateModulo();
            setLstSelecionadosVinculados([]);
            setLstSelecionadosDesvinculados([]);
        });
    }

    return (
        <>
            <div className="d-flex mt-2">
                <div className="col-12 col-lg-6">
                    <ModulosVinculados
                        lstDocumentosTemplatesModulo={
                            lstDocumentosTemplatesModulo
                        }
                        lstDocumentosTemplatesModuloLoading={
                            lstDocumentosTemplatesModuloLoading
                        }
                        lstSelecionadosVinculados={lstSelecionadosVinculados}
                        setLstSelecionadosVinculados={
                            setLstSelecionadosVinculados
                        }
                        HandleDesvincularModuloUnico={
                            HandleDesvincularModuloUnico
                        }
                        HandleDesvincularModuloTodos={
                            HandleDesvincularModuloTodos
                        }
                        DesvincularTemplateModulosLoading={
                            DesvincularTemplateModulosLoading
                        }
                    />
                </div>
                <div className="col-md-6">
                    <ModulosDesvinculados
                        lstDocumentosTemplatesModulo={
                            lstDocumentosTemplatesModulo
                        }
                        lstDocumentosTemplatesModuloLoading={
                            lstDocumentosTemplatesModuloLoading
                        }
                        lstSelecionadosDesvinculados={
                            lstSelecionadosDesvinculados
                        }
                        setLstSelecionadosDesvinculados={
                            setLstSelecionadosDesvinculados
                        }
                        HandleVincularModuloUnico={HandleVincularModuloUnico}
                        HandleVincularModulosTodos={HandleVincularModulosTodos}
                        VincularModulosAoTemplateLoading={
                            VincularModulosAoTemplateLoading
                        }
                    />
                </div>
            </div>
        </>
    );
}
